import { NgModule} from '@angular/core';
import { PdvService } from './services/pdv/pdv.service';
import { OrdersService } from './services/order/orders.service';
import { WebSiteUsersService } from './services/webSiteUsers/webSiteUsers.service';
import { AuthService } from './services/Auth/auth.service';
import { AuthGuard } from './services/AuthGuard/AuthGuard';
import { HostService } from './services/host/host.service';
import { ConstService } from './services/const/const.service';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClientJsonpModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AddHeaderInterceptor } from './services/AddHeaderInterceptor/AddHeaderInterceptor';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { frLocale } from 'ngx-bootstrap/locale';
defineLocale('fr', frLocale);
import { ModalsModule } from '@app/modules/modals/modals.module';
import { IngredientService } from './services/ingredient/ingredient.service';
import { localStorageService } from './services/localStorage/localStorage.service';
import { HelpycurrencyModule } from './pipes/helpycurrency/helpycurrency.module';
import { GoogleLoginProvider,FacebookLoginProvider,AuthServiceConfig } from './modules/angular-6-social-login-master';
export function socialConfigs() {  
  const config = new AuthServiceConfig(  
    [  
      {  
        id: FacebookLoginProvider.PROVIDER_ID,  
        provider: new FacebookLoginProvider(PdvService.facebookId)  
      },  
      {  
        id: GoogleLoginProvider.PROVIDER_ID,  
        provider: new GoogleLoginProvider(PdvService.googleId)  
      }  
    ]  
  );  
  return config;  
} 

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    HttpClientModule,
    FormsModule,
    BrowserModule.withServerTransition({appId: 'my-app'}),
    AppRoutingModule,
    BrowserAnimationsModule,
    ModalModule.forRoot(),
    HttpClientJsonpModule,
    ModalsModule,
    HelpycurrencyModule
  ],
  providers: [
    HostService,
    ConstService,
    AuthService,
    WebSiteUsersService,
    PdvService,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddHeaderInterceptor,
      multi: true,
    },
    OrdersService,
    IngredientService,
    localStorageService,  
    {  
      provide: AuthServiceConfig,  
      useFactory: socialConfigs  
    }  
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
